import { Injectable } from "@angular/core";
import { ReplaySubject } from "rxjs";

@Injectable()
export class I18nService {
	private language: string;

	language$ = new ReplaySubject<string>(Infinity);

	setLanguage(language: string) {
		this.language = language;

		this.language$.next(language);
	}

	getLanguage() {
		return this.language;
	}
}
